import { render, staticRenderFns } from "./peopleDetailsDialog.vue?vue&type=template&id=1a0191f2&"
import script from "./peopleDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./peopleDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./peopleDetailsDialog.vue?vue&type=style&index=0&id=1a0191f2&prod&lang=less&module=true&"
import style1 from "./peopleDetailsDialog.vue?vue&type=style&index=1&id=1a0191f2&prod&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports